import { render, staticRenderFns } from "./DashboardWidgetAsWindow.vue?vue&type=template&id=0c3bc2f4&scoped=true"
import script from "./DashboardWidgetAsWindow.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetAsWindow.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetAsWindow.vue?vue&type=style&index=0&id=0c3bc2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bc2f4",
  null
  
)

export default component.exports